$(function() {
  $('.js-checkbox-singular input[type="checkbox"]').on('click',function(){
    var checkBoxName = $(this).attr('name');
    if($(this).prop('checked')){
      $('[name="'+checkBoxName+'"]').each(function(){
        $(this).prop('checked', false);
      });
      $(this).prop('checked', true);
    }
  });

  $('.js-search-detail-toggle').on('click',function(){
    $(this).toggleClass('active');
    $('.js-search-detail').slideToggle();
  })

  $('.js-search-reset').on('click',function(){
    $('#search-form')
      .find("textarea, :text, select").val("").end()
      .find(":checked").prop("checked", false);
    $('#search-count').text(dynamic_total);

  });

  // 前回セッションに保存した物件を取得
  $('.check-property').prop('disabled', true);
  accessApi(requestUrlApiGet, 'GET');

  // 選択した物件をセッションに保存
  $('.check-property').on('change', function() {
    $('.check-property')
      .filter(':not(:checked)')
      .prop('disabled', true);
    accessApi(requestUrlApiStore, 'POST', {
      propertyId: $(this).val(),
      isChecked: $(this).is(':checked')
    });
  });
  
  // 検索条件に該当する物件数を取得
  $('#search-form select, #search-form :checkbox').on('change', function() {
    let requestData = { 
      interest:null,
      minPrice:null,
      maxPrice:null,
      sellPrice:null,
      type:{},
      electric:{},
      landForm:{},
      area:{},
      other:{}
    };
    $('#search-form select').each(function(i, elem) {
      requestData[elem.name] = elem.value;
    });
    $('#search-form input[type="checkbox"]').filter(':checked').each(function(i, elem) {
      let inputName = elem.name.replace('[]', '');
      let key = Object.keys(requestData[inputName]).length;
      requestData[inputName][key] = elem.value;
    });
    accessApi(requestUrlApiSearch, 'POST', requestData, true);
  });

  // API
  function accessApi(requestUrl, type, requestData=null, isSearch=false) {
    $.ajax({
      type: 'POST',
      url: requestUrl,
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
      },
      dataType: 'json',
      data: requestData,
    })
    .done(function(response) {
      if(response.result == 1) {
        console.log(response);
        if(isSearch) {
          $('#search-count').text(response.count);
        } else {
          $('#checked-count').text(response.count);

          if(type == 'GET') {
            let idList = response.idList;
            for(let i=0; i<idList.length; i++) {
              $('#' + idList[i]).prop('checked', true);
            }
          }
          $('.check-property').filter(':checked').prop('disabled', false);
          if(response.isMax) {
            $('.check-property').filter(':not(:checked)').prop('disabled', true);
          } else {
            $('.check-property').prop('disabled', false);
          }
        }
      }
    })
    .fail(function(XMLHttpRequest, textStatus, errorThrown){
      console.log(textStatus);
      alert('エラーが発生しました、ブラウザのログを確認してください');
    });
  }
});
